import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'name', label: 'name', sortable: true },
    { key: 'region', label: 'Region', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
    ...tableConfig('district'),
  }
}
